import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

export default class ToolService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public UploadFileLinh(file): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/tool/CLinh`, file, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public UploadFileMejlinh(file): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/tool/Mejlinh`, file, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public UploadFileTien(params, file): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/tool/CTien?` + this.convertObjectParamToStrings.convertObjectParamToStrings(params), file, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public UploadFileTienLinh(params, file): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/tool/CTienClinh?` + this.convertObjectParamToStrings.convertObjectParamToStrings(params), file, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public AllFeetype(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/feeType", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
